import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = { class: "dropdown__title" }
const _hoisted_3 = {
  key: 0,
  class: "dropdown__content"
}
const _hoisted_4 = { class: "dropdown__item-name" }
const _hoisted_5 = { class: "dropdown__item-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", {
      class: "dropdown__trigger",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVisible && _ctx.toggleVisible(...args)))
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["dropdown__btnstatus", {'rotated': _ctx.visible}])
      }, "+", 2)
    ]),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "dropdown__item",
              key: index
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.price), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}